import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import { alpha } from "@mui/material";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "../sideBar";
import Loading from "../../../components/loading/loading";
import { getAllTutors } from "../../../state/slices/admin";

const AllTutorsPage = () => {
  const theme = useMuiTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { allTutors, loading } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(getAllTutors());
  }, [dispatch]);

  const getTutorProfileStatus = (value) => {
    if (!value || value === "NOT_STARTED") return "New";
    if (value === "PENDING") return "Pending Review";
    if (value === "APPROVED") return "Approved";
    if (value === "REJECTED") return "Rejected";
    return value;
  };

  const columns = [
    { field: "user", headerName: t("dashboard.user"), width: 220 },
    { field: "email", headerName: t("common.email"), width: 260 },
    { field: "phoneNumber", headerName: t("common.phoneNumber"), width: 170 },
    { field: "profileStatus", headerName: t("dashboard.profileStatus"), width: 180 },
    { field: "registrationDate", headerName: t("dashboard.registrationDate"), width: 170 },
  ];

  const rows = (allTutors || []).map((item) => ({
    id: item._id,
    user: item.userId
      ? `${item.userId.firstName || ""} ${item.userId.lastName || ""}`.trim() || "N/A"
      : "N/A",
    email: item.userId?.email || "N/A",
    phoneNumber: item.userId?.phoneNumber || "N/A",
    profileStatus: getTutorProfileStatus(item.profileStatus),
    registrationDate: item.registrationDate
      ? new Date(item.registrationDate).toLocaleDateString()
      : "N/A",
  }));

  const CustomNoRowsOverlay = () => (
    <GridOverlay>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          color: "secondary",
        }}
      >
        <Typography variant="h6">{t("dashboard.noTutors")}</Typography>
      </Box>
    </GridOverlay>
  );

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: alpha(theme.palette.primary.main, 0.03) }}>
      <Grid container>
        <Grid item xs={12} md={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} md={10}>
          <Box sx={{ p: { xs: 2, md: 4 } }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                mb: 3,
              }}
            >
              {t("dashboard.tutorDetails")} - {t("request.all")}
            </Typography>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              }}
            >
              <div style={{ height: 600, width: "100%" }}>
                {loading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <Loading />
                  </Box>
                ) : (
                  <DataGrid
                    columns={columns}
                    rows={rows}
                    columnHeaderHeight={60}
                    disableSelectionOnClick
                    components={{
                      NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                    sx={{
                      "& .MuiDataGrid-row:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.05),
                      },
                    }}
                  />
                )}
              </div>
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AllTutorsPage;
